// Tooltip State Constants
export const TOOLTIP_VISIBLE = "TOOLTIP_VISIBLE";
export const TOOLTIP_CURRENT_ID = "TOOLTIP_CURRENT_ID";
export const TOOLTIP_CURRENT_STEP = "TOOLTIP_CURRENT_STEP";
export const TOOLTIP_GUIDANCE_ENABLED = "TOOLTIP_GUIDANCE_ENABLED";
export const TOOLTIP_COMPLETED = "TOOLTIP_COMPLETED";
export const TOOLTIP_DISMISSED = "TOOLTIP_DISMISSED";
export const SET_TOOLTIP_VISIBILITY = "SET_TOOLTIP_VISIBILITY";
export const SET_TOOLTIP_CURRENT = "SET_TOOLTIP_CURRENT";
export const SET_TOOLTIP_STEP = "SET_TOOLTIP_STEP";
export const COMPLETE_TOOLTIP = "COMPLETE_TOOLTIP";
export const SKIP_TOOLTIP = "SKIP_TOOLTIP";
export const SET_USER_PREFERENCES = "SET_USER_PREFERENCES";
export const INIT_TOOLTIPS = "INIT_TOOLTIPS";
export const SHOW_WELCOME_TOOLTIPS = "SHOW_WELCOME_TOOLTIPS";
export const HIDE_WELCOME_TOOLTIPS = "HIDE_WELCOME_TOOLTIPS";

// Tooltip Storage Keys
export const TOOLTIP_PREFERENCES_KEY = "hcms_tooltip_preferences";
export const COMPLETED_TOURS_KEY = "hcms_completed_tours";
export const DISMISSED_TOOLTIPS_KEY = "hcms_dismissed_tooltips";
